import { Navigate, useParams } from "react-router-dom";

/** Fill a path pattern's `:params` from the current URL's, each URI-encoded. */
export function fillPathParams(pattern: string, params: Readonly<Record<string, string | undefined>>): string {
	return pattern.replace(/:(\w+)/g, (_, name: string) => encodeURIComponent(params[name] ?? ""));
}

/** Renders a registry entry's `redirectsFrom` route: a retired URL, sent on to its current page
 *  with its `:params` carried over. */
export function LegacyRedirect({ to, search = "" }: { to: string; search?: string }) {
	const params = useParams();
	return <Navigate to={`${fillPathParams(to, params)}${search}`} replace />;
}
